import React, { useEffect, useCallback, useState } from "react";
import { Typography, Form, Button, Input, message } from "antd";
import UserApi from "../common/Apis/UserApi";
import { WarningOutlined, MailOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";

const { Title } = Typography;

const EmailVerification = (props) => {
  let navigate = useNavigate();
  const [verified, setVerified] = useState(true);
  const [error, setError] = useState(false);
  const [loading, setLoading] = useState(false);
  const [form] = Form.useForm();
  
  const urlParams = new URLSearchParams(window.location.search);
  const token = urlParams.get("token");

  const verifyRegistration = useCallback(() => {
    if (token) {
      UserApi.verifyRegistration(token)
        .then((response) => {
          return navigate("/");
        })
        .catch((err) => {
          setError(true);
        });
    } else {
      return navigate("/");
    }
  }, [token]);

  useEffect(() => {
    verifyRegistration();
  }, [verifyRegistration]);

  const handleResendVerification = (data) => {
    setLoading(true);
    const email = data.email;
    
    UserApi.resendVerifyToken(email)
      .then((response) => {
        setVerified(false);
        // Clear the email input field
        form.resetFields();
        message.success("Verification email has been sent successfully!");
      })
      .catch((err) => {
        message.error("Failed to send verification email. Please try again.");
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <div className="container form-container">
      <Title className="logo-title">iVA Connect</Title>
      <div className="row justify-content-center ">
        <Title className="sub-title text-center pt-0">Email Verification</Title>
        <div className="col-xl-9 col-lg-9 col-md-12 p-0 pb-5">
          <div className="card-body ">
            {error === true && (
              <>
                <div className="question-border ">
                  <Form
                    form={form}
                    name="email-form"
                    layout="vertical"
                    onFinish={handleResendVerification}
                    autoComplete="off"
                  >
                    {verified === true ? (
                      <>
                        <div className="warning-alert d-flex mt-3">
                          <WarningOutlined className="warning-icon" />
                          <div className="warning-content">
                            <h5>Email verification failed!</h5>
                            <p>
                              The verification code does not match our record.
                            </p>
                          </div>
                        </div>

                        <p className="mb-4">
                          Please enter your email address to receive a new verification mail.
                        </p>
                      </>
                    ) : (
                      <>
                        <div className="warning-alert d-flex mt-3">
                          <WarningOutlined className="warning-icon" />
                          <div className="warning-content">
                            <h5>Your email is not verified.</h5>
                            <p>Please verify your email address.</p>
                          </div>
                        </div>

                        <p className="mb-4">
                          If you didn't receive the verification email, please enter your email address below to resend it.
                        </p>
                      </>
                    )}

                    <Form.Item
                      name="email"
                      label="Email Address"
                      rules={[
                        {
                          required: true,
                          message: "Please enter your email address",
                        },
                        {
                          type: "email",
                          message: "Please enter a valid email address",
                        },
                      ]}
                    >
                      <Input
                        prefix={<MailOutlined />}
                        placeholder="Enter your email address"
                        size="large"
                      />
                    </Form.Item>

                    <div className="d-flex justify-content-center">
                      <Button
                        type="primary"
                        htmlType="submit"
                        className="btn btn-primary btn-submit"
                        loading={loading}
                      >
                        {verified ? "Send Verification Email" : "Resend Verification Email"}
                      </Button>
                    </div>
                  </Form>
                </div>
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default EmailVerification;